import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createCustomer } from '../api/customersApi';

// No client-side cache invalidation — the backend broadcasts UpdateCustomerTable
// to the tenant group after SaveChangesAsync, and useCustomers already invalidates
// ['customers'] on that event (including for the creating tab). SignalR is the
// single sync mechanism; mirroring it here would just double-fetch.
export default function useCreateCustomer() {
    return useMutation({
        mutationFn: createCustomer,
        onSuccess: () => toast.success('Customer created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create customer'),
    });
}
